module.controller('signupOrderCtrl', [ 'cardOrderService',  'authService', 'signupOrderDataService', '$state', '$http', 'baseURI', 'Transform', 'ENROLLMENT_ERROR', 'Session', 'referrerService', '$window', 'localStorageService', 'LimitsService', '$q','brandService', function(cardOrderService, authService, signupOrderDataService, $state, $http, baseURI, Transform, ENROLLMENT_ERROR, Session, referrerService, $window, localStorageService, LimitsService, $q, brandService) {

  var vm = this;
  var orderDataValues = {};
  vm.verificationFlag = false;
  vm.showBack = true;
  vm.cardOrderService = cardOrderService;
  vm.createMore = createMore;
  vm.goBack = goBack;
  vm.hideModal = hideModal;
  vm.clearSsn = clearSsn;
  vm.placeOrder = placeOrder;
  vm.brand = brandService.getBrand(Session.getBrand());
  checkIfLoggedIn();

  ///////////////////////////////

  function checkIfLoggedIn() {
    if (!authService.isAuthenticated()) {
      $state.go('signup.signin');
    } else {
      loadCards();
    }
  }

  function defineOrderData() {
    if (vm.cards[0]) {
      orderDataValues =  localStorageService.get('orderDataValues');

      vm.orderData = {
        "FirstName" : vm.cards[0].FirstName,
        "LastName" : vm.cards[0].LastName
      };

      if(orderDataValues !== null ){
        vm.orderData.StreetAddress = orderDataValues.StreetAddress;
        vm.orderData.SuiteNumber = orderDataValues.SuiteNumber;
        vm.orderData.City = orderDataValues.City;
        vm.orderData.State = orderDataValues.State;
        vm.orderData.Zipcode = orderDataValues.ZipCode;
        vm.orderData.Dob = orderDataValues.Dob;
      }
    }
  }

  function loadCards() {
    cardOrderService.loadCards()
      .then(function(data) {
        vm.cards = data;
        defineOrderData();
      }, function(error){
        console.log(error);
      });
  }

  function createMore() {
    cardOrderService.createCard();
    $state.go('signup.create');
  }

  function clearSsn(){
    vm.orderData.Ssn = '';
  }


  vm.goToDashboard = function(state){
    $q.all([
      authService.checkStatus(),
      authService.getFeatureAccess(),
      LimitsService.update()
    ]).then(function(results){

      try {
        // set status and feature access
        authService.setStatusSession(results[0].data);
        authService.setFeatureAccessSession(results[1].data);
      } catch (e) {
        Rollbar.error(e);
      }
      //set the dashboard to be in verification state
      Session.setEnrollmentErrorCode(150);
      //go to the dashboard
      $state.go(state);

    }).catch(function(err){
      Rollbar.error(err);
    });

  };
  function hideModal(){
    vm.submitted = false;
    vm.errorShow = !vm.errorShow;
    clearSsn();

  }
  function goBack() {
    vm.submitted = false;

    if(orderDataValues !== null ){

      orderDataValues = {
        'StreetAddress':  vm.orderData.StreetAddress,
        'SuiteNumber': vm.orderData.SuiteNumber,
        'City': vm.orderData.City ,
        'State': vm.orderData.State ,
        'Zipcode': vm.orderData.Zipcode ,
        'Dob': vm.orderData.Dob ,
      };

    }
    else{
      orderDataValues = {
        'StreetAddress': "",
        'SuiteNumber': "",
        'City': "" ,
        'State': "" ,
        'Zipcode': "" ,
        'Dob': "" ,
      };
    }
    localStorageService.set('orderDataValues', orderDataValues);
    if (authService.isAuthenticated()) {
      $state.go('signup.customize');
    } else {
      $state.go('signup.signin');
    }
  }

  function placeOrder(isValid) {
    vm.submitted = true;
    if (isValid) {
      vm.submitted = false;
      vm.loading = true;
      if(!vm.orderData.Ssn && vm.orderData.NoSsn){
        vm.orderData.Ssn = '222222222';
      }

      vm.orderData.cardsQty = vm.cards.length;
      signupOrderDataService.save(vm.orderData);
      vm.orderData.Referrer = referrerService.get();

      $http({
        url: baseURI + 'reloadable-card/create',
        method: 'POST',
        headers: {'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'},
        data: Transform.encode(vm.orderData)
      }).then(function (resp){
        var data = resp.data;

        if(data.Success){
          sendGAConversion();

          $state.go('signup.confirmation');
        } else {
          vm.loading = false;

          // code from step-2-3-joinCtrl.js we should remove duplication
          if(data.ErrorCode == 100){
            switch(data.VendorErrorCode){
              case '1075':
                //need SSV
                vm.verificationFlag = true;
                vm.showBack = true;
                vm.errorMessage = "Almost there! In order to better protect your identity, we require some documentation before we can open your account. Please continue to the account dashboard where you can upload an image of your Social Security Card or W-2 Form.";
                vm.errorShow = true;
                vm.loading = false;
                break;
              case '1077':
                //bad Proof of Address
                vm.verificationFlag = true;
                vm.showBack = true;
                vm.errorMessage = "Looks like the address you entered could not be verified. Please update your address so we can complete your enrollment. ";
                vm.errorShow = true;
                vm.loading = false;
                break;
              case '1050':
              case '1076':
                //need drivers license
                vm.verificationFlag = true;
                vm.showBack = true;
                vm.errorMessage = "We were unable to confirm some of the information you provided. In order to better protect your identity, we require some documentation before we can open your account. Please continue to the account dashboard where you can upload an image of your driver's license or government-issued ID card. You may also click to back button to review and resubmit the information you have provided.";
                vm.errorShow = true;
                vm.loading = false;
                break;
              case '965':
                vm.verificationFlag = false;
                vm.errorMessage = 'Oops, looks like you have already signed up with an account.';
                vm.errorShow = true;
                vm.loading = false;
                break;
              case '942':
              case '1052':
                vm.verificationFlag = false;
                vm.errorMessage = 'Sorry, but we cannot ship cards to a P.O. Box. Please try again using a street address.';
                vm.errorShow = true;
                vm.loading = false;
                break;
              default:
                vm.verificationFlag = false;
                vm.errorMessage = ENROLLMENT_ERROR[1] + data.VendorErrorCode;
                vm.errorShow = true;
                vm.loading = false;
                break;
            }
          } else if(data.Error === 150){
            //fraud filter
            vm.verificationFlag = true;
            vm.showBack = false;
            vm.errorMessage = "Almost there! In order to better protect your identity, we require some documentation before we can open your account. Please continue to the account dashboard where you can upload an image of your driver's license or government-issued ID card.";
            vm.errorShow = true;
            vm.loading = false;
          }
          else {
            vm.verificationFlag = false;
            vm.errorMessage = ENROLLMENT_ERROR[2];
            vm.errorShow = true;
            vm.loading = false;
            vm.showBack = true;
          }
        }
      }).catch(function (error){
        if(error.data.ErrorCode === 20){
          vm.showBack = true;
          vm.verificationFlag = false;
          vm.errorMessage = 'You need to enter values all required fields.';
          vm.errorShow = true;
          vm.loading = false;
        }
        else if(error.data.ErrorCode == 184) {
          vm.verificationFlag = false;
          vm.errorMessage = 'Oops, the invitation code provided does not appear to be correct. In order to enroll, you must provide a valid invitation code.';
          vm.loading = false;
          vm.errorShow = true;
          vm.showBack = true;
        }
        else if(error.data.ErrorCode === 150) {
          //passport documentation needed if NoSSN flag was selected
          vm.showBack = true;
          vm.verificationFlag = true;
          vm.errorMessage = "Almost there! In order to better protect your identity, we require some documentation before we can open your account. Please continue to the account dashboard where you can upload an image of your Passport or ID card. Please note: Since you did not provide a Social Security Number, we cannot accept any ID documentation issued by the U.S. You may also click the back button and provide your SSN if you have one.";
          vm.errorShow = true;
          vm.loading = false;
        }
        else{
          vm.verificationFlag = false;
          vm.errorMessage = ENROLLMENT_ERROR[1] + 100;
          vm.errorShow = true;
          vm.loading = false;
        }
      });
    }
  }

  var sendGAConversion = function(){
    gtag('event', 'signup_order_conversion', {
      'send_to': 'G-N24N1YZ4VJ',
      'value': 1.00,
      'currency': 'USD'
    });
    gtag('event', 'signup_order_conversion', {
      'send_to': 'G-FZYCZK58SP',
      'value': 1.00,
      'currency': 'USD'
    });
  };

}]);
